import TablePaginaitonTemplate from '@v2/commons/templates/TablePaginationTemplate/TablePaginationTemplate.template'
import { WbfPolicies } from '@workers-benefit-fund/shared-data'

import withErrorBoundaryAndPolicyCheck from 'src/v2/commons/HOC/ErrorBoundaryAndPolicyCheckHOC'
import { TBreadCrumbItems } from 'src/v2/commons/components/Breadcrumb'

import EscalationTable from '../components/EscalationTable/escalationTable.component'
import EscalationTableFilter from '../components/EscalationTableFilters/escalationTableFilter.component'
import { useGetEscalations } from '../hooks/useGetEscalations.hook'

const breadCrumbItems: TBreadCrumbItems = [
  { title: 'Home' },
  { title: 'Escalations' },
]
const Filters = withErrorBoundaryAndPolicyCheck(
  EscalationTableFilter,
  'is_escalation_filters_enabled',
  true,
)

const Table = withErrorBoundaryAndPolicyCheck(
  EscalationTable,
  WbfPolicies.is_get_escalations_enabled,
)

const EscalationTableView = () => {
  const {
    escalations,
    isLoading,
    handlePaginate,
    handleOrderBy,
    filterOrderBy,
    totalRecords,
    paginationLimitField,
    tablePage,
    isFetching,
    isError,
    escalationFiltersForm,
    isProgrammaticFormUpdateRef,
    setFiltersOpen,
    filtersOpen,
  } = useGetEscalations()

  return (
    <TablePaginaitonTemplate
      isLoading={isLoading}
      isFetching={isFetching}
      isError={isError}
      isRecords={escalations.length > 0}
      handlePaginate={handlePaginate}
      paginationLimitField={paginationLimitField}
      currentPage={tablePage}
      totalRecords={totalRecords}
      title="Escalations"
      emptyPageTerm="Escalation"
      header={<></>}
      breadCrumbItems={breadCrumbItems}
      loadingSkeletonProps={{ height: 30 }}
      filters={
        <Filters
          isProgrammaticFormUpdateRef={isProgrammaticFormUpdateRef}
          totalRecords={totalRecords}
          escalationFiltersForm={escalationFiltersForm}
          setFiltersOpen={setFiltersOpen}
          filtersOpen={filtersOpen}
          escalations={escalations}
        />
      }
    >
      <Table
        escalations={escalations}
        handleOrderBy={handleOrderBy}
        filterOrderBy={filterOrderBy}
      />
    </TablePaginaitonTemplate>
  )
}

export default withErrorBoundaryAndPolicyCheck(
  EscalationTableView,
  WbfPolicies.is_escalations_table_enabled,
)
